import React from 'react';
import { randPhoto } from '../../Utils/Photo.js';
import resume from '../../Resources/Files/titov.pdf';
import icon2 from '../../Resources/Icons/galaxy.svg';
import icon3 from '../../Resources/Icons/earth.svg';
import icon4 from '../../Resources/Icons/moon-and-stars.svg';
import icon5 from '../../Resources/Icons/alien.svg';
import icon6 from '../../Resources/Icons/blue-ball.svg';

import vk from '../../Resources/Icons/VK Logo 2.svg';
import telegramm from '../../Resources/Icons/telegram.svg';
import mail from '../../Resources/Icons/email.svg';
import tel from '../../Resources/Icons/phone.svg';
import habr from '../../Resources/Icons/habr.svg';

export default function MyWay() {
  return (
    <section className='myWay'>
      <div className='cards-container-grid'>
        <div className='card card-images-social'>
          <img src={randPhoto()} className='card__image' alt='Фотография' />
          <div className='card__social-container'>
            <a
              href='mailto:N3kto.1@yandex.ru?body=У твоего любимого заказчика появился вопрос'
              target='_blank'
              rel='noreferrer'
            >
              <img
                src={mail}
                className='card__social-link'
                alt='Иконка социальной сети'
              />
            </a>
            <a href='https://t.me/TitovAV' target='_blank' rel='noreferrer'>
              <img
                src={telegramm}
                className='card__social-link'
                alt='Иконка социальной сети'
              />
            </a>
            <a href='https://vk.com/idtens91' target='_blank' rel='noreferrer'>
              <img
                src={vk}
                className='card__social-link'
                alt='Иконка социальной сети'
              />
            </a>
            <a
              href='https://career.habr.com/titovav12'
              target='_blank'
              rel='noreferrer'
            >
              <img
                src={habr}
                className='card__social-link'
                alt='Иконка социальной сети'
              />
            </a>
            <a href='Tel:89101636692' target='_blank' rel='noreferrer'>
              <img
                src={tel}
                className='card__social-link'
                alt='Иконка социальной сети'
              />
            </a>
          </div>
        </div>
        <div className='card'>
          <h2 className='card__title'>Титов Андрей Витальевич</h2>
          <p className='card__text'>Возраст: {new Date().getFullYear() - 1991} года</p>
          <p className='card__text'>Семейное положение: женат</p>
          <p className='card__text'>
          Место проживания: Россия, г.&nbsp;Тула
          </p>
          <p className='card__text'>Общий стаж работы: 10 лет</p>
          <p className='card__text'>Стаж работы в IT: более 6 лет</p>
          <p className='card__text'>Готов к переезду: г.&nbsp;Москва</p>
        </div>
      </div>
      <div className='cards-container-flex'>
        {/* Основная работа */}
        <div className='card-horizontal card-horizontal_blue'>
          <h2 className='card__title'>Основная работа на текущий момент</h2>
          <p className='card__text'>
            ООО "Бастион"
          </p>
          <p className='card__text'>
            Должность - Аудитор DevSecOps
          </p>
          <p className='card__text'>
            Обязанности делятся на несколько направлений:
          </p>
          <ul className='card__text-ul'>
            <li className='card__text-li card__text-li_horizontal'>
              Разработка методологии оценки процессов безопасной разработки программного обеспечения
            </li>
            <li className='card__text-li card__text-li_horizontal'>
              Проведение аудита процессов безопасной разработки программного обеспечения
            </li>
            <li className='card__text-li card__text-li_horizontal'>
              Разработка конкретных рекомендаций для построения/усовершенствования процессов безопасной разработки
            </li>
          </ul>
          <a
          href={resume}
          target='_blank'
          className='card__link'
          rel='noreferrer'
        >
          Мое резюме 
        </a>
        {/* <img
            src={icon2}
            className='card__icon card__icon-right'
            alt='Изображение'
          /> */}
        </div>
        {/* Фриланс */}
        <div className='card-horizontal'>
          <h2 className='card__title'>Опыт фриланса</h2>
          <p className='card__text'>
            Я фрилансер с опытом работы в различных областях. Выполняю работу
            качественно и в срок. Опыт позволяет разрабатывать сайты для бизнеса
            и небольшие информационные системы. Есть опыт создания различных
            сайтов, например на платформе Битрикс24, самописных с применением
            React.js и без применения фреймворков на чистом HTML и CSS.
          </p>
          <img
            src={icon3}
            className='card__icon card__icon-right'
            alt='Изображение'
          />
        </div>
        {/* Курсы */}
        <div className='card-horizontal card-horizontal_blue'>
          <h2 className='card__title'>Курсы и повышение квалификации</h2>
          <p className='card__text'>
            Очень люблю учиться и повышать свою квалификацию. В наше время
            технологии развиваются очень быстро, и чтобы оставаться
            востребованным специалистом, нужно постоянно узнавать что-то новое и
            совершенствоваться в своей профессии. Поэтому я всегда с радостью
            использую возможность пройти новые курсы или тренинги.
          </p>
          {/* Пентест */}
          <p className='card__text card__text-bold'>
           Август 2023 — Ноябрь 2024 АНО ДПО «Образовательные технологии Яндекса»{' '}
          </p>
          <ul className='card__text-ul'>
            <li className='card__text-li card__text-li_horizontal'>
              Пройденна программа повышения квалификации «Специалист по информационной безопасности: веб-пентест» 
            </li>
            <li className='card__text-li card__text-li_horizontal'>
              Улучшенные навыки: DevSecOps, тестирование на проникновение Web-приложений, SAST, DAST, OSA
            </li>
          </ul>
          {/* Основы продакт-менеджмента */}
          <p className='card__text card__text-bold'>
           Ноябрь 2023 — Февраль 2024 АНО ДПО «Образовательные технологии Яндекса»{' '}
          </p>
          <ul className='card__text-ul'>
            <li className='card__text-li card__text-li_horizontal'>
              Пройденна программа повышения квалификации «Основы продакт-менеджмента» 
            </li>
            <li className='card__text-li card__text-li_horizontal'>
              Улучшенные навыки: продуктовое мышление, процесс проверки идеи на жизнеспособность, проведение исследований, валидация решения проблемы, презентация идеи, разработка и тестирование MVP, масштабирование
            </li>
          </ul>
          {/* Техническая защита информации */}
          <p className='card__text card__text-bold'>
            Апрель 2022 — Июль 2022 УДПО "Региональный центр безопасности"{' '}
          </p>
          <ul className='card__text-ul'>
            <li className='card__text-li card__text-li_horizontal'>
              Пройденный курс профессиональной переподготовки по направлению "Техническая защита информации ограниченного
              доступа, не содержащей сведения, составляющие государственную
              тайну"
            </li>
            <li className='card__text-li card__text-li_horizontal'>
              Улучшенные навыки: Защита информации, Информационная безопасность,
              Системное администрирование, Сетевая безопасность
            </li>
          </ul>
          {/* Организация криптографической защиты */}
          <p className='card__text card__text-bold'>
            Декабрь 2021 — Февраль 2022 УДПО "Региональный центр безопасности"{' '}
          </p>
          <ul className='card__text-ul'>
            <li className='card__text-li card__text-li_horizontal'>
              Пройденный курс профессиональной переподготовки по направлению "Организация криптографической защиты
              конфиденциальной информации на объектах информатизации"
            </li>
            <li className='card__text-li card__text-li_horizontal'>
              Улучшенные навыки: работа с Linux, Системное администрирование,
              Криптография, Юриспруденция, Безопасность сетей, Информационная
              безопасность, Защита информации
            </li>
          </ul>
          {/* Веб-разработчик */}
          <p className='card__text card__text-bold'>
            Октябрь 2021 — Октябрь 2022 АНО ДПО «Образовательные технологии
Яндекса» Россия, Москва{' '}
          </p>
          <ul className='card__text-ul'>
            <li className='card__text-li card__text-li_horizontal'>
              Пройденна программа профессиональной переподготовки
«Веб-разработчик»
            </li>
            <li className='card__text-li card__text-li_horizontal'>
              Улучшенные навыки: Git, Linux, SQL, ООП, MongoDB, Nginx,
              JavaScript, Node.js, React, HTML, CSS, Адаптивная верстка
            </li>
          </ul>
          {/* Управление проектами */}
          <p className='card__text card__text-bold'>
            Май 2021 — Сентябрь 2021 АНО «Университет Национальной
            технологической инициативы 2035»{' '}
          </p>
          <ul className='card__text-ul'>
            <li className='card__text-li card__text-li_horizontal'>
              Пройденный курс повышения квалификации "Методы и технологии, основанные на работе с
              данными" 
            </li>
            <li className='card__text-li card__text-li_horizontal'>
            Улучшенные навыки: Управление проектами, Проектное планирование, Построение команды,
              Ведение переговоров, Agile, Разработка ТЗ, Управление разработкой,
              Оптимизация бизнес-процессов, Стратегическое планирование. В ходе
              обучения разработал&nbsp;
            </li>
          </ul>
          <img
            src={icon4}
            className='card__icon card__icon-right'
            alt='Изображение'
          />
        </div>
        {/* Работа до It */}
        <div className='card-horizontal'>
          <h2 className='card__title'>Жизнь до IT</h2>
          <p className='card__text'>Я не всегда был разработчиком</p>
          <p className='card__text'>Май 2015 — Январь 2019</p>
          <p className='card__text'>
            Управление по административно-техническому надзору администрации
            города Тулы
          </p>
          <p className='card__text'>
            Должность - Консультант сектора контроля по Центральному
            территориальному округу управления по административно-техническому
            надзору администрации города Тулы.
          </p>
          <p className='card__text'>Обязанности и достижения</p>
          <p className='card__text'>
            Реализация контрольных функций в сфере муниципальной политики
            благоустройства территории и внешнего облика муниципального
            образования город Тула, муниципального жилищного контроля, контроля
            за использованием и сохранностью муниципального имущества
            муниципального образования город Тула, муниципального контроля за
            сохранностью автомобильных дорог местного значения в границах
            муниципального образования город Тула, работа с обращениями граждан.
            В отсутствии начальника сектора исполнения его обязанностей.
          </p>
          <p className='card__text'>
            Участвовал в ревитализации культурного центра и контроле за
            производством работ при реконструкции Казанской набережной города
            Тулы.
          </p>

          <p className='card__text'>Октябрь 2013 — Май 2015</p>
          <p className='card__text'>
            Искал себя в разных компаниях и понял, что пора двигаться дальше
          </p>
          <p className='card__text'>Должность - много чего делающий человек</p>
          <p className='card__text'>Октябрь 2012 — Октябрь 2013</p>
          <p className='card__text'>Служба в армии</p>
          <p className='card__text'>Должность - солдат</p>
          <p className='card__text'>Сентябрь 2008 — Июнь 2012</p>
          <p className='card__text'>Учился в институте</p>
          <p className='card__text'>Должность - студент</p>
          <img
            src={icon5}
            className='card__icon card__icon-right'
            alt='Изображение'
          />
        </div>
      </div>
      <div className='card-horizontal card-horizontal_blue'>
        <h2 className='card__title'>О себе</h2>
        <p className='card__text'>
          Люблю учится и применять новые знания на практике. Вежлив,
          неконфликтен, умею находить общий язык с коллегами и руководством.
        </p>
        <p className='card__text'>Имеется опыт:</p>
        <ul className='card__text-ul'>
          <li className='card__text-li card__text-li_horizontal'>
          разработки микросервисной архитектуры для высоконагруженной информационной системы
          </li>
          <li className='card__text-li card__text-li_horizontal'>
          разработки схем описывающих взаимодействия информационных систем ﻿
 и потоки данных
          </li>
          <li className='card__text-li card__text-li_horizontal'>
          ключевого участия в разработке проекта на React в качестве тимлида
          </li>
          <li className='card__text-li card__text-li_horizontal'>
          создания и организации работы отдела разработки состоящего из двух команд и отдела руководителей проектов
          </li>
          <li className='card__text-li card__text-li_horizontal'>
          организации и проведения межрегиональных семинаров в формате онлайн и офлайн
          </li>
          <li className='card__text-li card__text-li_horizontal'>
          богатый опыт выступлений на различных семинарах и форумах
          </li>
          <li className='card__text-li card__text-li_horizontal'>
          создания регламентов и внутренней документации компании
          </li>
          <li className='card__text-li card__text-li_horizontal'>
          опыт руководства несколькими командами разработки
          </li>
          <li className='card__text-li card__text-li_horizontal'>
            опыт ведения переговоров с крупными заказчиками в лице региональных
            министерств информатизации
          </li>
        </ul>
        <p className='card__text'>
          Разработал и зарегистрировал ИС «Для меня», которая предназначена для
          создания цифровой инфраструктуры, направленной на планирование и учет
          тренировок. 
        </p>
        <p className='card__text'>
          Свидетельство о государственной регистрации №2023661909
        </p>
        <p className='card__text'>
          Спроектировал и разработал систему самостоятельно (frontend, backend,
          БД, документация), попробовал себя в качестве
          разработчика полного цикла с фиксацией рабочих задач на доске, работал
          в выходные дни, очень интересный опыт получился.
        </p>
        <p className='card__text'>
          Увлекаюсь музыкой, живописью, разработкой игр и сайтов. Люблю играть в
          настольные игры.
        </p>
        <img
          src={icon6}
          className='card__icon card__icon-right'
          alt='Изображение'
        />
      </div>
      <div className='card-horizontal'>
        <h2 className='card__title'>
          Буду рад поучаствовать в вашем проекте !
        </h2>
        <p className='card__text'>
          Я профессиональный разработчик с большим опытом работы в разных
          сферах. Опыт работы позволяет руководить командой разработки и
          занимать место программиста одновременно. Буду&nbsp;рад помочь вам с
          вашими проектами и улучшить ваши сервисы. Жду&nbsp;ваших предложений и
          готов обсудить условия сотрудничества.
        </p>
        <a
          href={resume}
          target='_blank'
          className='card__link'
          rel='noreferrer'
        >
          Мое резюме
        </a>
      </div>
    </section>
  );
}
